
import { Modal, ModalBody, ModalBodyTheme, ModalContentTheme, ModalFooter, ModalHeader, ModalHeaderTheme, ModalProps, ModalRootTheme } from "flowbite-react";
import React from "react";

type ModalWrapperProps = ModalProps & {
   actions?: React.ReactNode
   children: React.ReactNode
   title?: string,
   rootTheme?: Partial<ModalRootTheme>
   contentTheme?: Partial<ModalContentTheme>
   headerTheme?: Partial<ModalHeaderTheme>
   bodyTheme?: Partial<ModalBodyTheme>
   footerTheme?: Partial<ModalBodyTheme>
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({ actions, children, title, size, rootTheme, contentTheme, headerTheme, bodyTheme, footerTheme, ...restProps }) => {
   const headerThemeDefault = {
      base: 'flex justify-center text-center !pt-7.5 !px-7.5',
      title: 'font-bold text-sx',
      close: {
         base: "absolute right-2 top-2 rounded-md cursor-pointer",
         icon: "text-primaryInteract"
      }
   }

   const bodyThemeDeafault = {
      base: `px-7.5 ${title && '!pt-3.5'} pb-0 overflow-y-auto min-h-7.5 ${!actions && 'mb-7.5'}`,
   }

   const footerThemeDefault = {
      base: "px-7.5 pb-7.5 justify-center",
   }

   return (
      <Modal
         popup
         size={size || "lg"}
         theme={{
            root: rootTheme,
            content: contentTheme
         }}
         {...restProps}
      >
         <ModalHeader theme={headerTheme ?? headerThemeDefault}>
            {title}
         </ModalHeader>
         <ModalBody theme={bodyTheme ?? bodyThemeDeafault}>
            {children}
         </ModalBody>
         {actions !== undefined && <ModalFooter theme={footerTheme ?? footerThemeDefault}>
            {actions}
         </ModalFooter>}
      </Modal>
   )
}

export default ModalWrapper
